<template>
	<div class="flex justify-center">
		<div>
			<vs-pagination v-bind="$attrs" v-on="$listeners" :max="paginationMax" />
		</div>
	</div>
</template>

<script>
export default {
	name: "CbsPagination",
	inheritAttrs: false,
	computed: {
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		paginationMax() {
			let _total = this.$attrs.total;
			if(this.windowWidth < 576) {
				_total = _total > 5 ? 5 : _total;
			}

			if(this.windowWidth < 768) {
				_total = _total > 7 ? 7 : _total;
			}

			if(this.windowWidth >= 768) {
				_total = _total > 9 ? 9 : _total;
			}

			return _total % 2 === 0 ? _total + 1 : _total;
		}
	}
};
</script>
